import React from "react";
import "./index.scss";

const DrinkResponsibly = () => (
  <span className="drink-responsibly">drink responsibly</span>
);

export default DrinkResponsibly;
